/**
 * Paths được phép truy cập theo từng role – chỉ hiển thị và cho vào đúng trang tương ứng.
 */

/** Trang mặc định sau khi chọn role (redirect khi truy cập path không được phép). */
export function getHomePathForRole(role: string): string {
  const staffRoles = ['secretary', 'judge', 'admin', 'chief_judge']
  return staffRoles.includes(role) ? '/workspace' : '/cases'
}

/** Kiểm tra pathname có được phép với role hay không. */
export function isPathAllowedForRole(pathname: string, role: string): boolean {
  const base = pathname.split('?')[0]

  // Mọi role đều được /profile
  if (base === '/profile') return true

  // Đương sự / litigant / student: /cases, /cases/new, /cases/:id, /profile
  if (['user', 'litigant', 'student'].includes(role)) {
    if (base === '/cases' || base === '/cases/new') return true
    if (base.startsWith('/cases/')) return true
    return false
  }

  // Chánh án: workspace (dashboard, preliminary-chief, assign, reports, settings, documents-pending, ai-*), profile
  if (role === 'admin' || role === 'chief_judge') {
    if (base === '/workspace') return true
    if (base.startsWith('/workspace/cases')) return true
    if (base === '/workspace/calendar') return true
    if (base === '/workspace/preliminary-chief') return true
    if (base.startsWith('/workspace/assign')) return true
    if (base === '/workspace/reports') return true
    if (base === '/workspace/settings') return true
    if (base === '/workspace/documents-pending') return true
    if (base === '/workspace/ai-draft' || base === '/workspace/ai-evidence' || base === '/workspace/ai-research') return true
    if (base === '/workspace/ai-court-secretary') return true
    return false
  }

  // Thư ký: workspace (trừ assign, reports, settings), cases, preliminary, calendar, video, ai-draft, ai-evidence, ai-research
  if (role === 'secretary') {
    if (base === '/cases' || base.startsWith('/cases/')) return true
    if (base === '/workspace') return true
    if (base.startsWith('/workspace/preliminary')) return true
    if (base.startsWith('/workspace/cases')) return true
    if (base === '/workspace/calendar') return true
    if (base === '/workspace/video') return true
    if (base === '/workspace/ai-draft' || base === '/workspace/ai-evidence' || base === '/workspace/ai-research') return true
    if (base === '/workspace/ai-court-secretary') return true
    return false
  }

  // Thẩm phán: như Thư ký + ai-research + documents-pending
  if (role === 'judge') {
    if (base === '/cases' || base.startsWith('/cases/')) return true
    if (base === '/workspace') return true
    if (base.startsWith('/workspace/cases')) return true
    if (base === '/workspace/calendar') return true
    if (base === '/workspace/video') return true
    if (base === '/workspace/documents-pending') return true
    if (base === '/workspace/ai-draft' || base === '/workspace/ai-evidence' || base === '/workspace/ai-research') return true
    if (base === '/workspace/ai-court-secretary') return true
    return false
  }

  return false
}
